var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandVoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.11529 12.5641H5.38451C4.61946 12.5641 3.88574 12.2602 3.34477 11.7192C2.80379 11.1782 2.49988 10.4445 2.49988 9.67946C2.49988 8.91441 2.80379 8.18069 3.34477 7.63972C3.88574 7.09874 4.61946 6.79483 5.38451 6.79483H7.11529V12.5641Z",
    stroke: "#0C5CEF",
    strokeWidth: 0.73,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.11548 12.5642C10.501 12.5645 13.8107 13.5665 16.6278 15.4442L17.5002 16.0257V3.33333L16.6278 3.91487C13.8107 5.79253 10.501 6.79461 7.11548 6.79489L7.11548 12.5642Z",
    stroke: "#0C5CEF",
    strokeWidth: 0.73,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.11548 12.5646C7.11499 13.3199 7.26817 14.0675 7.56572 14.7617C7.86326 15.456 8.29895 16.0825 8.84626 16.603",
    stroke: "#0C5CEF",
    strokeWidth: 0.73,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandVoice);
export default __webpack_public_path__ + "static/media/brandVoice.835663fbd2c5917529b11484a73ef7f0.svg";
export { ForwardRef as ReactComponent };